<template>
  <div>
    <div class="yuan_fl">
      <div class="tisps_text">
        <span>    
          <span class="bor"></span>
          <span class="bor_text">声强正常</span>
        </span>
        <span>
          <span class="bor_h"></span>
          <span class="bor_text">声强偏高</span>
        </span>
      </div>
      
      <div id="yuan"></div>
    </div>

    <div class="rate_fl">
      <div id="rate"></div>
    </div>

    <div class="pie_fl">
      <div id="pie"> </div>
    </div>
    
  </div>
</template>


<script>
 import * as echarts from "echarts";
 import useSeep from '../MyChart/minix.js'
export default {
  props: {
    Bars:{
      type:Array,
      default:[]
    },
    static:{
      type:Number,
      default:0
    },
    rotateBar:{
      type:Array,
      default:[]
    },
    curtime:{
      type:Number,
      default:0
    },
    emitpielist:{
      type:Array,
      default:[]
    }
  },
  mixins: [useSeep],
  data () {
    return {
      myChart:{},
      option:{},
      
      initList:[],
      deflist:[],
      stic:0,
      definitList:[],


      Rbaroption:{},
      RbarMyChart:{},
      rotateBarList:[],

      usePie:{},
      PieOption:{},
      pieList:[],
      barmax:0
      
    }
  },
  created(){
  },
  mounted(){
    const self = this
    self.myChart = echarts.init(document.getElementById('yuan'));
    self.RbarMyChart = echarts.init(document.getElementById('rate'));
    self.usePie = echarts.init(document.getElementById('pie'));


    self.option = {
        title:{
          text:'声强曲线图/dB',
          textStyle:{
              color:'#757474',
              fontWeight:'normal',
              fontSize:self.RemText(0.13)
            },
          top:'3%'
        },
        grid: [
          {
            top:'30%',
            bottom: '16%',
          },
        ],
        visualMap:{
          show: false,
          dimension: 1,
          pieces:[
            {
              gte:60,
              color:'#ed39ce',
            },
            {
              gte:0,
              lt:60,
              color:'#2ed0d3',
            }
          ]
        },
        animationDuration: 0,
        xAxis: [
          {
            type: 'category',
            name: '时间/h',
            // boundaryGap: false,
            nameTextStyle :{
              fontSize: 11,
              padding: [52, 0, 0, -20]
            },
            axisLine: {
              show: true,
              lineStyle: {
                 color: '#797676'
              }
            },
            axisTick:{              //删除点线
              show:false,
            },
            axisLabel: {
              show: false, // 不显示坐标轴上的文字
            },
          },
          {
            type: 'category',          
            axisTick:{              //删除点线
              show:false,
            },
            position: "bottom",
            axisLine: {
              show: true,
              lineStyle: {
                color: '#797676'
              }
            },
            splitLine: {
              //网格线
              lineStyle: {
                type: "solid", //设置网格线类型 dotted：虚线   solid:实线
                color: "rgba(117, 116, 116, 0.3)"
              },
              show: true, //隐藏或显示
            },
            axisLabel:{
              padding: [0, -35, 0, 0],
            },
            data: ['','',4,3,2,1,0],
          },
        ],
        yAxis: [
          {
          type: 'value',
          name: '声强/dB',
          nameTextStyle :{
            fontSize: 11,
            padding: [0, 0, 0, -20]
          },
          max:90,
          min:40,
          axisLine: {
            show: true,
            lineStyle: {
               color: '#797676'
            }
          },
          axisTick:{              //删除点线
            show:false,
          },
        },
        ],
        series: [
          {
            type: 'line',
            large: true,
            showSymbol: false,
            largeThreshold: 1000,
            itemStyle: {
              normal: {
               color: '#797676'
              }
            },

            label: {
                normal: {
                    show: true,
                    position: 'top'
                }
            },
            data: [],
          }
        ]
    };

    self.Rbaroption = {
        title: {
          text: '频谱图/Hz',
          textStyle:{
            color:'#797676',
            fontWeight:'normal',
            fontSize:self.RemText(0.13)
          },
          top:'3%'
        },
        grid: [
          {
            bottom: '10%',
            right:'14%',
            left:'13%'
          },
        ],
        xAxis: {
          type: 'value',
          name: '声强/dB',
          position:'top',
          inverse: true,
          max:0,
          nameTextStyle :{
					  fontSize: 10,
            padding: [0, -12, 5, 0]
				  },
          axisLine: {
            show: false,
            lineStyle: {
              color: '#797676'
            }
          },
          axisTick:{              //删除点线
            show:false,
          },
          splitLine: {
            //网格线
            lineStyle: {
              type: "solid", //设置网格线类型 dotted：虚线   solid:实线
              color: "rgba(210, 210, 210, 0.5)"
            },
            show: true, //隐藏或显示
          },
        },
        yAxis: [
          {
            type: 'category',
            name: '频率/HZ',
            position: "right",
            nameTextStyle :{
              fontSize: 11,
              padding: [-5, -50, 0, 0]
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "rgba(121, 118, 118, 1)"
              }
            },
            axisLabel: {
              show: false, // 不显示坐标轴上的文字
            },
            axisTick:{              //删除点线
              show:false,
            },
            inverse: true,
          data: [],
        },
        {
          type: 'category',
          position: "right",
          nameTextStyle :{
            fontSize: 11,
            padding: [0, -50, 0, 0]
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "rgba(121, 118, 118, 1)"
            }
          },
          inverse: true,
          axisTick:{              //删除点线
            show:false,
          },
          splitLine: {
            //网格线
            lineStyle: {
              type: "solid", //设置网格线类型 dotted：虚线   solid:实线
              color: "rgba(121, 118, 118, 0.6)"
            },
            show: true, //隐藏或显示
          },
          axisLabel:{
            padding:[25,0,0,0]
          },
          data: [2000,4000,6000,8000],
        },
        ],
        series: [
          {
            data: [],
            type: 'bar',
            itemStyle: {
                normal: {
                  barBorderRadius:[20,0,0,20],
                  color:"#46c6c5"
                }
            },
          },
          {
            data: [0,0,0,0],
            type: 'bar',
            yAxisIndex:1
          }
        ]
    };

    self.PieOption = {
      title: {
        text: '噪声分类/频次',
        left: 'left',
        top:'5%',
        textStyle:{
          color:'#797676',
          fontWeight:'normal',
          fontSize:self.RemText(0.13)
        },
      },
      tooltip: {
        show:true,
        trigger: 'item',
        // formatter:"{d}%"
        formatter:"{b}:{c}， 占比：{d}%"

      },
      legend: {
        //   horizontal
        orient: 'vertical',
        left:'left',
        top:'25%',
      },
      series: [
        {
          // name: '',
          type: 'pie',
          radius: '70%',
          center: ['65%', '50%'],
          data: self.pieList,
          label: {
            normal: {
              show: false,
              position: 'inner', // 数值显示在内部
              formatter: '{d}%', // 格式化数值百分比输出
            },
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }
      ]
    }

    window.addEventListener("resize",function(){
      self.myChart.resize();
    })

    window.addEventListener("resize",function(){
      self.RbarMyChart.resize();
    })

    window.addEventListener("resize",function(){
      self.usePie.resize();
    })

    self.dwe();
    self.Rbardwe();

    setTimeout(()=>{
      self.setPie()
    },0)
  },
  
  methods:{
    RemText(res){
      let docEl = document.documentElement,
      clientWidth = window.innerWidth||docEl.clientWidth||document.body.clientWidth;
        
      if (!clientWidth) return;
      const fontSize = clientWidth / 15
      return res * fontSize;
    },


    dwe(){
      const self = this
      self.option.series[0].data = self.initList
      self.myChart.setOption(self.option);
     
    },

    Rbardwe(){
      const self = this

      if(self.Rbaroption.xAxis.max < self.barmax){
        self.Rbaroption.xAxis.max = self.barmax
      }
      self.Rbaroption.yAxis[0].data = self.rotaBar
      self.Rbaroption.series[0].data = self.rotateBarList
      self.RbarMyChart.setOption(self.Rbaroption);
    },

    setPie(){
      const self = this
      self.PieOption.series[0].data = self.pieList
      self.usePie.setOption(self.PieOption);
    },
  }
}
</script>


<style scoped lang="scss">
.yuan_fl{
  width: 20%;
  height: 40%;
  background-color: #fbfafa;
  position: absolute;
  top: 18.8vmin;
  left: 1%;
  .tisps_text{
    position: absolute;
    right: 10%;
    top: 13%;
    .bor{
      width: 1vmin;
      height: 1vmin;
      display: inline-block;
      background-color: #2ed0d3;
      border-radius: 0.1vmin;
    }
    .bor_text{
      font-size: 1vmin;
      color: #797676;
      margin-left: 0.3vmin;
    }
    .bor_h{
      width: 1vmin;
      height: 1vmin;
      display: inline-block;
      background-color:#ed39ce;
      border-radius: 0.1vmin;
      margin-left: 1vmin;
    }
  }
  #yuan{
    width: 98%;
    height: 100%;
    margin: 0 auto;
  }
}


.rate_fl{
  width: 22%;
  height: 35%;
  background-color: #fbfafa;
  position: absolute;
  top: 30%;
  right: 1%;
  #rate{  
    width: 98%;
    height: 100%;
    margin: 0 auto;
  }
}

.pie_fl{
  width: 22%;
  height: 28%;
  background-color: #fbfafa;
  position: absolute;
  top: 1%;
  right: 1%;
  #pie{  
    width: 98%;
    height: 100%;
    margin: 0 auto;
  }
}

</style>


// WEBPACK FOOTER //
// FuXiBar.vue?240dbd33